"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollStyles = void 0;
const lit_1 = require("lit");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
// 이게 왜 필요..
const scrollDirectionTokens = {
    row: { 'flex-direction': 'row', 'overflow-x': 'auto', 'overflow-y': 'hidden' },
    column: {
        'flex-direction': 'column',
        'max-height': '100%',
        'overflow-x': 'hidden',
        'overflow-y': 'auto',
    },
};
exports.scrollStyles = [
    (0, lit_1.css) `
    :host {
      --scroll-gap: 0;

      display: flex;
      gap: var(--scroll-gap);
      min-width: 0;
      max-width: 100%;

      ${shared_styles_1.scrollbarStyles};
    }

    ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('direction', scrollDirectionTokens))}

    ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('gap', (0, shared_styles_1.spaceTokens)('--scroll-gap')))}

    /* 항목은 줄어들어 프레임에 맞추지 않고 제 크기로 넘쳐 스크롤된다. */
    ::slotted(*) {
      flex-shrink: 0;
    }

    :host([hide-scrollbar]) {
      scrollbar-width: none;
    }

    :host([hide-scrollbar])::-webkit-scrollbar {
      display: none;
    }
  `,
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2Nyb2xsLnN0eWxlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNjcm9sbC5zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsNkJBQW9DO0FBRXBDLCtEQUE4RjtBQUM5RixtQ0FBbUU7QUFFbkUsWUFBWTtBQUNaLE1BQU0scUJBQXFCLEdBQW1DO0lBQzVELEdBQUcsRUFBRSxFQUFFLGdCQUFnQixFQUFFLEtBQUssRUFBRSxZQUFZLEVBQUUsTUFBTSxFQUFFLFlBQVksRUFBRSxRQUFRLEVBQUU7SUFDOUUsTUFBTSxFQUFFO1FBQ04sZ0JBQWdCLEVBQUUsUUFBUTtRQUMxQixZQUFZLEVBQUUsTUFBTTtRQUNwQixZQUFZLEVBQUUsUUFBUTtRQUN0QixZQUFZLEVBQUUsTUFBTTtLQUNyQjtDQUNGLENBQUE7QUFFWSxRQUFBLFlBQVksR0FBRztJQUMxQixJQUFBLFNBQUcsRUFBQTs7Ozs7Ozs7O1FBU0csK0JBQWU7OztNQUdqQixJQUFBLGVBQVMsRUFBQyxJQUFBLDJCQUFtQixFQUFDLFdBQVcsRUFBRSxxQkFBcUIsQ0FBQyxDQUFDOztNQUVsRSxJQUFBLGVBQVMsRUFBQyxJQUFBLDJCQUFtQixFQUFDLEtBQUssRUFBRSxJQUFBLDJCQUFXLEVBQUMsY0FBYyxDQUFDLENBQUMsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7R0FjckU7Q0FDRixDQUFBIn0=